<template>
    <!--FAQ start-->
  <section class="theme-bg-yellow testimonial" id="annual_report">
    <div class="container">
       <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
       <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-title">
  </div>
        </div>
      </div>
      <div class="row faq-row">
        <div class="col-lg-4">
            <div class="section-title">
            <h2 class="text-green" >1 ปี ก้าวไกล</h2>
            <h2 class="text-green" >ฝ่าวิกฤติยางพารายุค Covid-19</h2>
            <img :src='"../assets/images/green-line.png"' alt="title-line" class="img-fluid">
            <p>กยท. กับการดำเนินงานในสถานการณ์การแพร่ระบาดของเชื้อ Covid-19 ควบคู่กับการดูแลพี่น้องเกษตรกร สถาบันเกษตรกรชาวสวนยาง และผู้ประกอบกิจการยางทั่วประเทศ ผ่านมาตรการและโครงการสำคัญตลอด 1 ปี ภายใต้นโยบายภาครัฐ พร้อมก้าวสู่ปีที่ 7 มุ่งดำเนินงานให้สอดคล้องกับโลกยุคปัจจุบัน ภายใต้แนวคิด "กยท. ก้าวไกลยุคดิจิทัล"</p>
            <p> <button v-if="!isPlay" @click="play()"  class="btn btn-email" id="mc-submit">รับชมวิดีโอ</button></p>
          </div>
        </div>
        <div class="col-lg-8 text-center">
           <!-- <vue-core-video-player  :playsinline="true" :options="playerOptions"  ></vue-core-video-player> -->
           <Media 
      :kind="'video'"
      :ref="'rubbervideo'"
      :muted="false"
      :controls="true"
      :poster="'https://firebasestorage.googleapis.com/v0/b/deselatan.appspot.com/o/cover.jpg?alt=media&token=c4f9edc7-e70b-46be-9fa0-2612defd7ba2'"
      :loop="true"
      :autoplay="false"
      @play="playing()"
      :src="['https://youngcyber.xyz/halq/roat_6y.mp4']"
      :style="{width: '100%'}"
    >
    </Media>
        </div>
      </div>
    </div>
  </section>
    <!--FAQ end -->
</template>
<script>
import Media from '@dongido/vue-viaudio'
export default {
  name: 'FAQ',
  components: {
    Media
  },
  data() {
    return {
      isPlay: false,
      playerOptions: {
          height: '360',
          autoplay: true,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            // mp4
            src: "http://vjs.zencdn.net/v/oceans.mp",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/LOGO_.png/1200px-LOGO_.png",
        }
    }
  },
  mounted() {
     //this.$refs.rubbervideo.play() 
    
    this.play()
  
  },
  methods: {
   stop(){
     this.isPlay = false;
   },
   playing(){
     this.isPlay = true;
     
   },
    play(){
       setTimeout( () => {
        this.$refs.rubbervideo.play();
      }, 2000)
      
    }
  },
}
</script>
